Ext.define('SA.view.SelectedLocationsList', {
    alias: 'widget.selected-locations-list',
    extend: 'Ext.Container',

    autoScroll: true,
    cls: 'sa-selected-locations-list',

    plugins: [{
        ptype: 'sa-animation',
        duration: 250
    }],

    initComponent() {
        this.callParent();

        this.setLocations(this.locations);

        SA.LocationsReferenceTracker.registerReferencer(this);
    },

    addLocation(location) {
        var locations = this.locations;

        location = SA.data.LocationsCache.toLocationSeries(location);

        if (!locations.includes(location)) {
            locations.push(location);

            this.setLocations(locations);
        }
    },

    afterLayout() {
        var el = this.el,
            dom = el.dom;

        this.callParent(arguments);

        this.items.each(item => item.el.setStyle('width', null));

        SA.fixScrollbars(dom);

        if (this.scrollToBottom) {
            this.scrollToBottom = false;

            el.scrollTo('top', dom.scrollHeight - dom.clientHeight, true);
        }
    },

    beforeDestroy() {
        SA.LocationsReferenceTracker.unregisterReferencer(this);

        this.callParent();
    },

    clearLocations() {
        this.setLocations([]);
    },

    getLocations() {
        return this.locations.slice();
    },

    getReferencedLocations() {
        return this.getLocations();
    },

    refresh() {
        var locations = SA.data.LocationsCache.get(this.locations),
            oldItems = this.query('>*'),
            newItems = [],
            dom;

        locations.forEach(location => {
            var index = oldItems.findIndex(item => !item.hideTime && item.location === location);

            if (index !== -1) {
                oldItems.splice(index, 1);
                return;
            }

            newItems.push({
                xtype: 'selected-locations-list-item',
                location
            });
        });

        if (oldItems.length || newItems.length) {
            Ext.suspendLayouts();

            if (newItems.length) {
                dom = this.el;

                if (dom) {
                    dom = dom.dom;

                    if (dom.scrollTop >= dom.scrollHeight - dom.clientHeight) {
                        this.scrollToBottom = true;
                    }
                }

                this.add(newItems);
            }

            oldItems.forEach(item => {
                if (item.hideTime) {
                    if (item.hideTime < new Date() - 5000) {
                        item.destroy();
                    }
                }
                else {
                    item.hide();
                    item.hideTime = +new Date();
                }
            });

            Ext.resumeLayouts(true);
        }
    },

    removeLocation(location) {
        var locations = this.locations;

        location = SA.data.LocationsCache.toLocationSeries(location);

        if (locations.includes(location)) {
            this.setLocations(Ext.Array.remove(locations, location));
        }
    },

    setLocations(locations) {
        this.locations = (locations || []).map(SA.data.LocationsCache.toLocationSeries);

        this.refresh();

        this.fireEvent('change:locations', this);
    }
});

Ext.define('SA.view.SelectedLocationsList.Item', {
    alias: 'widget.selected-locations-list-item',
    extend: 'Ext.Component',

    autoEl: 'table',
    cls: 'sa-selected-locations-list-table',
    saAnim: true,

    tpl: [
        '<tbody>',
            '<tr class="sa-selected-locations-list-row">',
                '<td>',
                    '<div class="sa-selected-locations-list-item">',
                        '<span class="sa-selected-locations-list-item-name">{name}</span>',
                        '<tpl if="geographicUnit"><span class="sa-selected-locations-list-item-unit">{geographicUnit}</span></tpl>',
                    '</div>',
                '</td>',
                '<td class="sa-selected-locations-list-x-td">',
                    '<button aria-label="close" class="sa-selected-locations-list-x"><svg aria-hidden="true"><use href="#sa-icon-close"></use></svg></button>',
                '</td>',
            '</tr>',
        '</tbody>'
    ],

    initComponent() {
        var fm = Ext.util.Format,
            location = this.location,
            unit;

        if (!location.type) {
            unit = SA.data.GeographicUnits.get(location.geographicUnit).singularName;
        }

        this.data = {
            geographicUnit: unit,
            name: fm.locationRenderer(location)
        };

        this.callParent();
    },

    initEvents() {
        this.callParent();

        this.el.on({
            delegate: '.sa-selected-locations-list-x',
            scope: this,

            click() {
                Ext.suspendLayouts();

                this.up('selected-locations-list').removeLocation(this.location);

                Ext.resumeLayouts(true);
            },

            mouseout(ev, target) {
                Ext.fly(target).removeCls('sa-selected-locations-list-x-over');
            },

            mouseover(ev, target) {
                Ext.fly(target).addCls('sa-selected-locations-list-x-over');
            }
        });
    }
});
